import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Form from 'react-bootstrap/Form';


function ScheduleButton( { zone, send, disabled } ) {
    const [ d, setD ] = useState( '' );
    const [ hr, setHr ] = useState( 0 );
    const [ min, setMin ] = useState( 0 );
    const [ tz, setTimezone ] = useState( '' );
    const [ ampm, setAmPm ] = useState( 'AM' );
    const [ open, setOpen ] = useState( false );
    
    const hours = Array.from( { length: 12 }, ( v, i ) => i + 1 );
    const minutes = Array.from( { length: 60 }, ( v, i ) => i );
    const timezones = [
        'America/New_York',
        'America/Chicago',
        'America/Denver',
        'America/Phoenix',
        'America/Los_Angeles',
        'America/Anchorage',
        'Pacific/Honolulu'
    ];

    const handleClickOpen = () => {
        setOpen( true );
    };

    const handleClose = () => {
        setOpen( false );
    };

    const sendMessage = async ( now = true ) => {
        console.log( 'sendMessage: ' + now );

        if ( !now ) {
            let hour = hr;
            if ( ampm === 'AM' && hr === 12 ) {
                hour = 0;
            } else if ( ampm === 'PM' && hr < 12 ) {
                hour = parseInt( hr ) + 12;
            }
            
            handleClose();
            await send( d, `${hour}:${min}`, tz );
        } else {
            handleClose();
            await send();
        }
    };

    useEffect( () => {
        const now = new Date();
        var dd = String( now.getDate() ).padStart( 2, '0' );
        var mm = String( now.getMonth() + 1 ).padStart( 2, '0' ); //January is 0!
        
        setD( now.getFullYear() + '-' + mm + '-' + dd );

        if ( now.getHours() < 12 ) {
            setAmPm( 'AM' );
            setHr( now.getHours() === 0 ? 12 : now.getHours() );
        } else {
            setAmPm( 'PM' );
            setHr( now.getHours() - 12 );
        }
        setMin( now.getMinutes() );
    }, [] );

    useEffect( () => {
        if ( zone ) {
            setTimezone( zone );
        }
    }, [ zone ] );

    return (
        <div>
            <Dropdown as={ButtonGroup}>
                <Button className='tf-obj-button' size='sm' onClick={ () => sendMessage() } disabled={disabled}>Send</Button>
                <Dropdown.Toggle split className='tf-obj-button' id="dropdown-split-basic" disabled={disabled}>
                    <Dropdown.Menu id="dropdown-basic-button">
                        <Dropdown.Item onClick={ () => handleClickOpen() }>Schedule for Later</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown.Toggle>
            </Dropdown>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Schedule For Later</DialogTitle>
                <DialogContent>
                    <Container fluid>
                        <Row>
                            <Col><Form.Control type='date' value={d} onChange={ ( e ) => setD( e.target.value ) } placeholder='' /></Col>
                        </Row>
                        <Row className='pt-3 align-items-center'>
                            <Col xs='auto' className='pe-1'>
                                <Form.Select size='sm' className='tf-modal-select-input' value={hr} onChange={ ( e ) => setHr( e.target.value ) }>
                                    {
                                        hours.map( v => <option key={`hour-${v}`} value={v}>{v}</option> )
                                    }
                                </Form.Select>
                            </Col>
                            <Col xs='auto' className='px-1 fw-bold'>:</Col>
                            <Col xs='auto' className='px-1'>
                                <Form.Select size='sm' className='tf-modal-select-input' value={min} onChange={ ( e ) => setMin( e.target.value ) }>
                                    {
                                        minutes.map( v => <option key={`minute-${v}`} value={v}>{v}</option> )
                                    }
                                </Form.Select>
                            </Col>
                            <Col xs='auto' className='px-1'>
                                <Form.Select size='sm' className='tf-modal-select-input' value={ampm} onChange={ ( e ) => setAmPm( e.target.value ) }>
                                    <option value='AM'>AM</option>
                                    <option value='PM'>PM</option>
                                </Form.Select>
                            </Col>
                        </Row>
                        <Row className='pt-3'>
                            <Col xs='auto'>
                                <Form.Select size='sm' className='tf-modal-select-input' value={tz} onChange={ ( e ) => setTimezone( e.target.value ) }>
                                    {
                                        timezones.map( ( v, i ) => <option key={`tz-${i}`} value={v}>{v}</option> )
                                    }
                                </Form.Select>
                            </Col>
                        </Row>
                    </Container>
                </DialogContent>
                <DialogActions>
                    <Button onClick={ () => sendMessage( false ) } color="primary">
                        Schedule
                    </Button>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

const mapProps = ( state ) =>( {
    zone: state.user.tz
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( ScheduleButton );
